import { defineWidgetSettings } from "@nexus/widget-sdk";
import { MISSING_DATA_CONFIG } from "@nexus/widget-kit";

/** What an author sets on the stacked category bars. */
export const settings = defineWidgetSettings({
  id: "stacked-category-bars",
  extends: [MISSING_DATA_CONFIG],
  properties: {
    // One tenant among those the report covers; offered once the report has tenants.
    tenantId: {
      type: "integer",
      title: "Show tenant",
      "x-ui": {
        category: "data",
        order: 30,
        options: { from: "binding-tenants", request: "series" },
        emptyLabel: "All tenants of the report",
      },
    },
    showDetails: {
      type: "boolean",
      title: "Summary and data note",
      description: "Shown around the chart",
      default: false,
      "x-ui": { category: "display", group: "show", order: 20, summary: "Summary" },
    },
  },
});
